import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { UserserviceService } from '../userservice.service';
import { SidebarService } from '../sidebar.service';
import Swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import e from 'express';
import { LoaderService } from '../loader.service';
import { ModelserviceService } from '../modelservice.service';
import { popup } from '../popup';
import { translatedData } from '../dashboard';
import { TranlationService } from '../tranlation.service';
import { Subscription } from 'rxjs';
import { FirebaseService } from '../firebase.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.css'],
})
export class NavigationComponent implements OnInit, OnDestroy {
    isAccountSettingOpen: boolean = false;
    isTitleOpen: boolean = false;
    titleForm!: FormGroup;
    deletedItemSubscription!: Subscription;
    language: any;
    translatedData1 = translatedData;
    dashbaordData = this.translatedData1.dashboard;
    shortname: any = '';
    constructor(
        private auth: UserserviceService,
        private side: SidebarService,
        private formBuilder: FormBuilder,
        private loader: LoaderService,
        private openModel: ModelserviceService,
        private translator: TranlationService,
        private firebase: FirebaseService
    ) {
        this.language = localStorage.getItem('lang');
        if (this.language == undefined || this.language == null) {
            this.language = 'en';
            localStorage.setItem('lang', this.language);
        }
        this.translation();
        this.loader.updateVideo$.subscribe(() => {
            console.log('refresh titles');
            this.getData();
        });

        this.deletedItemSubscription = this.firebase.deletedItem$.subscribe(
            (deleted) => {
                if (deleted == true) {
                    this.getAllWorkspaces(this.uid);
                    this.getData();
                }
            }
        );
    }
    uid!: any;
    id: any;
    ngOnInit(): void {
        this.translator.translationData$.subscribe((data) => {
            if (data) {
                this.navigation = data.navigation;
                this.changeLang();
            }
        });
        this.uid = localStorage.getItem('uid')?.toString();
        this.getData();
        this.getAllWorkspaces(this.uid);
        this.titleForm = this.formBuilder.group({
            title: ['', Validators.required],
            email: ['', Validators.required],
            created_at: new Date(),
            created_by: ['', Validators.required],
            status: 0,
        });
    }
    navigation = translatedData.navigation;
    customerDetails: any;
    name: any;
    openDropdown(id: any) {
        this.dropDown.map((x: any) => {
            if (x.data.id == id && x.data.status == 0) {
                x.data.status = 1;
                localStorage.setItem('currentTitle', id);
                setTimeout(() => {
                    this.loader.updateVideoStatus(true);
                }, 1000);
            } else {
                x.data.status = 0;
            }
        });
    }

    ngOnDestroy(): void {
        // Unsubscribe to prevent memory leaks
        this.deletedItemSubscription.unsubscribe();
    }

    async getAllWorkspaces1(uid: any) {
        try {
            // Make sure the `uid` parameter is validated (optional but recommended)
            if (!uid) throw new Error('User ID is required.');

            // Call the `getWorkspaces` method from the `auth` service
            const workspaces = await this.auth.getWorkspaces(uid);

            // Return the workspaces directly
            return workspaces;
        } catch (err) {
            // Log the error with more detail and consider re-throwing it
            console.error('Failed to get workspaces:', err);
            throw new Error(
                'Failed to retrieve workspaces. Please try again later.'
            );
        }
    }

    getData() {
        this.auth
            .getDetailsData(this.uid)
            .then((result) => {
                this.customerDetails = result;
                this.titleForm.controls['email'].setValue(
                    this.customerDetails.email
                );

                if (
                    this.customerDetails.firstName != undefined ||
                    this.customerDetails.firstName != null
                ) {
                    this.name = `${this.customerDetails.firstName} ${this.customerDetails.lastName}`;
                    this.shortname = `${this.name[0]}`;
                } else {
                    this.name = this.customerDetails.email.split('@')[0];
                    this.shortname = `${this.name[0]}`;
                }
                this.titleForm.controls['created_by'].setValue(this.name);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    studioTitle: string = '';

    logout() {
        this.closeModal1();
        this.auth.logout();
    }
    clicked: boolean = false;

    async SaveTitle() {
        this.loader.show();

        try {
            // Fetch all workspaces for the user
            const workspaces = await this.getAllWorkspaces1(this.uid);

            // Check if there is already a workspace with the same title
            const isTitleDuplicate = workspaces.some(
                (workspace: any) =>
                    workspace.title === this.titleForm.value.title
            );

            if (isTitleDuplicate) {
                this.popup = {
                    header: 'Error',
                    mainContent: 'Title Name Duplication',
                    leftButton: 'Cancel',
                    rightButton: 'Ok',
                };
                this.openModel.openModel(this.popup);
                return;
            }

            // Set form values
            this.titleForm.controls['created_at'].setValue(Date.now());
            this.titleForm.controls['status'].setValue(0);

            // Save new workspace
            this.clicked = true;
            await this.auth.saveWorkspace(this.uid, this.titleForm.value);

            // Fetch updated workspaces and other data
            await Promise.all([
                this.getAllWorkspaces(this.uid),
                this.getData(),
                this.firebase.addItem(),
            ]);

            this.popup = {
                header: 'Title Created',
                mainContent: 'Your new title has been created successfully.',
                leftButton: '',
                rightButton: 'Ok',
            };
            this.openModel.openModel(this.popup);
        } catch (err) {
            this.popup = {
                header: 'Error',
                mainContent: 'You Have error while processing',
                leftButton: 'Cancel',
                rightButton: 'Ok',
            };
            this.openModel.openModel(this.popup);
            console.error('Error saving workspace:', err);
        } finally {
            // Reset form and update the UI
            this.titleForm.reset();
            this.closeModal();
            this.clicked = false;
            this.loader.hide();
        }
    }

    //  async SaveTitle(){
    //   this.loader.show()
    //   try{
    // const workspaces= await this.getAllWorkspaces1(this.uid)
    // let canFound;
    // if(workspaces && workspaces.length>0){
    //  canFound=workspaces.filter((x:any)=>x.title==this.titleForm.value.title)
    // }

    // if(canFound){
    //   console.log('same name ')
    //   return
    // }
    //  this.titleForm.controls['created_at'].setValue(Date.now());
    //  this.titleForm.controls['status'].setValue(0);

    // this.clicked=true;

    //  await this.auth.saveWorkspace(this.uid,this.titleForm.value)

    //   }catch(err){
    // console.log(err)
    //   }finally{
    //     this.titleForm.reset()
    //     this.closeModal()
    //     // this.open()
    //     this.clicked=false;
    //     this.getAllWorkspaces(this.uid)
    //     this.getData()

    //    this.firebase.addItem()
    // this.loader.hide()
    //   }

    //   }

    hideSideBar() {
        if (window.innerWidth < 768) {
            this.side.hideSidebar();
        }
    }

    changeLanguage(event: Event) {
        this.loader.show();
        this.language = (event.target as HTMLInputElement).value;
        localStorage.setItem('lang', this.language);
        console.log(this.translatedData1);
        this.translation();
    }
    base: string = './assets/language/';
    url: string = '';
    translation() {
        switch (this.language) {
            case 'hi':
                this.url = `${this.base}hindi.json`;
                break;
            case 'zh-CN':
                this.url = `${this.base}mandarin.json`;
                break;
            case 'ko':
                this.url = `${this.base}korean.json`;
                break;
            case 'es':
                this.url = `${this.base}spanish.json`;
                break;
            case 'fr':
                this.url = `${this.base}french.json`;
                break;
            case 'ja':
                this.url = `${this.base}japanese.json`;
                break;
            case 'pt':
                this.url = `${this.base}portuguese.json`;
                break;
            case 'it':
                this.url = `${this.base}italian.json`;
                break;
            default:
                this.url = 'english.json';
                break;
        }
        if (this.url == 'english.json') {
            console.log(this.translatedData1);
            this.translator.loadTranslationData(this.translatedData1);
        } else {
            console.log(this.url, 'url');
            this.translator.readJsonFile(this.url).subscribe({
                next: (res) => {
                    this.translator.loadTranslationData(res);
                    console.log(res, 'get hindi data');
                    // this.saveToFile(res,'italian.json')
                    // localStorage.setItem('static',JSON.stringify(res))
                    this.loader.hide();
                },
                error: (err) => {
                    console.log(err);
                    this.loader.hide();
                },
            });
        }

        // this.translator.translateObject(this.translatedData1,this.language).subscribe({
        //   next:(res)=>{
        //     this.translator.loadTranslationData(res)
        //     console.log(res)
        //     this.saveToFile(res,'italian.json')
        //     localStorage.setItem('static',JSON.stringify(res))
        //      this.loader.hide()
        //   },
        //   error:(err)=>{
        //     console.log(err)
        //     this.loader.hide()

        //   }
        // })
        console.log('language change');
    }

    switchCase() {
        switch (this.language) {
            case 'hi':
                return 'hindi.json';
            case 'zh-CN':
                return 'mandarin.json';
            case 'ko':
                return 'korean.json';
            case 'es':
                return 'spanish.json';
            case 'fr':
                return 'french.json';
            case 'ja':
                return 'japanese.json';
            case 'pt':
                return 'portuguese.json';
            case 'it':
                return 'italian.json';
            default:
                return 'english.json';
        }
    }

    popup!: popup;

    open(content: any) {
        console.log('open');
        this.openModel.openModel(content);
    }
    // open() {
    //   this.popup={
    //     header:'Congratulations',
    //     mainContent:'Title Added Successfully',
    //     leftButton:'Cancel',
    //     rightButton:'Ok'

    //   }
    //   this.openModel.openModel(this.popup);
    // }

    @ViewChild('modalCloseButton') modalCloseButton!: ElementRef;

    closeModal() {
        const button: any = this.modalCloseButton.nativeElement;
        button.click();
    }

    @ViewChild('modalCloseButton1') modalCloseButton1!: ElementRef;

    closeModal1() {
        const button: any = this.modalCloseButton1.nativeElement;
        button.click();
    }

    dropDown: any[] = [];
    getAllWorkspaces(uid: any) {
        this.dropDown = [];
        this.auth
            .getWorkspaces(uid)
            .then((result) => {
                // console.log(result,'bjkhb')
                result.map((x: any) => {
                    // console.log(x,'xxx')
                    this.dropDown.push({ role: 'Admin', data: x });
                });
                //  console.log(this.dropDown,'d.....................')
                if (this.dropDown.length == 0) {
                    this.titleForm.controls['title'].setValue('Title #1');
                    this.titleForm.controls['email'].setValue(
                        this.customerDetails.email
                    );
                    this.titleForm.controls['created_by'].setValue(this.name);
                    this.SaveTitle();
                }
                this.getMemberWorkspace();
                //  console.log(this.dropDown,'drop')
            })
            .catch((err) => {
                console.log(err);
            });
    }

    workspace: any;
    role: any = '';
    async getMemberWorkspace() {
        // console.log(this.customerDetails.workspaces,'member')
        this.workspace = this.customerDetails.workspaces;
        this.workspace.map(async (element: any) => {
            // console.log(element.role,'ele')
            const role = element.role;
            await this.auth
                .getMemberWorkspace(element.userAccessuid, element.workspaceId)
                .then((result) => {
                    // console.log(result,'workshop')
                    if (result != null) {
                        this.dropDown.push({ role: role, data: result });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            this.changeLang();
            //  console.log(this.dropDown,'dp')
        });
    }

    changeLang() {
        const language = localStorage.getItem('lang');

        // if(language){
        //   Promise.all(this.dropDown.map(async (z: any) => {
        //     z.data.title = await this.translator.translateText(z.data.title, language);
        //   }));
        // }
    }
}
